import * as React from "react";

import BaseTemplate from "./Components/Templates/BaseTemplate";

const routes = [
  {
    path: "*",
    element: <BaseTemplate data-testid="baseTemplate" />,
  },
];

export default routes;
